import * as React from "react";
import { Modal, ModalSize } from "../../../../misc/components/modal";
import { useWizard } from "../../../Hooks/UseWizard";
import { Correction, VisibleWizards } from "../../../Request/DcfRequestReducer";
import { CorrectionPreviewModal } from "../../CorrectionPreviewModal";
import { WizardActionTypes } from "../WizardTypings";
import { SelectedEntities, SwapLabelsSelector } from "./SwapLabelsSelector";
import { CorrectionTypesEnum } from "../../../../misc/api/apiTypes";

export interface SwapLabelsWizardProps {
    isVisible: boolean;
    originalValue: any;
    subjectIdFieldDisplayText: string;
    siteId: string;
    savedCorrections?: Correction[];
    onClose: () => void;
    onComplete: (corrections: Array<Correction>) => void;
}

export const SwapLabelsWizard = ({
    originalValue,
    isVisible,
    subjectIdFieldDisplayText,
    siteId,
    onClose,
    onComplete
}: SwapLabelsWizardProps) => {
    const { currentState, dispatch } = useWizard();

    const [newLabel, setNewLabel] = React.useState<SelectedEntities>(null);

    const handleSelectorNext = (form: SelectedEntities) => {
        setNewLabel({
            Subject: form.Subject,
            Visit: form.Visit,
            Session: form.Session
        });

        dispatch(WizardActionTypes.Next);
    };

    if (!isVisible) {
        return null;
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <SwapLabelsSelector
                    subjectIdFieldDisplayText={subjectIdFieldDisplayText}
                    originalSubjectValue={originalValue.subject}
                    originalVisitValue={originalValue.visit}
                    originalSessionValue={originalValue.session}
                    siteId={siteId}
                    onNext={form => handleSelectorNext(form)}
                />
            );
            break;
        case 1:
            const corrections = [
                { sourceCorrection: VisibleWizards.SwapLabels, correctionTypeId: CorrectionTypesEnum.SwapLabels, entity: "Session", field: "SubjectId", oldValue: originalValue.subject.id, newValue: newLabel.Subject.id, },
                { sourceCorrection: VisibleWizards.SwapLabels, correctionTypeId: CorrectionTypesEnum.SwapLabels, entity: "Session", field: "VisitId", oldValue: originalValue.visit.id, newValue: newLabel.Visit.id },
                { sourceCorrection: VisibleWizards.SwapLabels, correctionTypeId: CorrectionTypesEnum.SwapLabels, entity: "Session", field: "VisitName", oldValue: originalValue.visit.name, newValue: newLabel.Visit.name },
                { sourceCorrection: VisibleWizards.SwapLabels, correctionTypeId: CorrectionTypesEnum.SwapLabels, entity: "Session", field: "SessionId", oldValue: originalValue.session.id, newValue: newLabel.Session.id },
                { sourceCorrection: VisibleWizards.SwapLabels, correctionTypeId: CorrectionTypesEnum.SwapLabels, entity: "Session", field: "Label", oldValue: originalValue.session.name, newValue: newLabel.Session.name },
            ]

            page = (
                <CorrectionPreviewModal corrections={corrections}
                    miscCorrection={null}
                    onPrev={() => dispatch(WizardActionTypes.Previous)}
                    onNext={() => onComplete(corrections)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal
            show={true}
            header="Swap Session Labels"
            size={ModalSize.Large}
            closeModalHandler={onClose}
        >
            {page}
        </Modal>
    );
}
